import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const splideElements = document.querySelectorAll('.splide-posts-carousel');
	if (!splideElements.length) return;

	const splideOptions = {
		pagination: false,
		arrows: true,
		autoWidth: true,
		gap: 20,
		arrowPath: "M39.6173 18.597C40.1217 19.1014 40.1217 19.919 39.6173 20.4234L31.3986 28.6421C30.8943 29.1465 30.0765 29.1465 29.5722 28.6421C29.0678 28.1378 29.0678 27.3202 29.5722 26.8157L36.8778 19.5102L29.5722 12.2046C29.0678 11.7003 29.0678 10.8826 29.5722 10.3783C30.0765 9.87391 30.8943 9.87391 31.3986 10.3783L39.6173 18.597ZM0.515831 18.2188L38.7042 18.2188V20.8017H0.515831V18.2188Z",
	};

	splideElements.forEach(element => {
		new Splide(element, splideOptions).mount();
	});
});